// extracted by mini-css-extract-plugin
export default {"container":"cZ-z","title":"dZ-z","link":"eZ-z"};